module.exports = "/assets/12b3ccef234b65228d7d9de73402c658.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BR.png
// module id = 2369
// module chunks = 0